<template>
    <v-container>
        <h2>Bowler Management</h2>
        <v-layout row wrap>
            <v-flex md3 v-for="component in bowler_components" ma-3>
                <component :is="component"></component>
            </v-flex>
            <v-flex md3 ma-3>
                <select-and-submit
                        title="Deactivate Bowler"
                        label="Bowler"
                        :items=selecteableActiveBowlers
                        btn-label="Deactivate"
                        hasbtn=True
                        :onsubmit=deactivateBowler>

                </select-and-submit>
            </v-flex>
            <v-flex md3 ma-3>
                <select-and-submit
                        title="Activate Bowler"
                        label="Bowler"
                        :items=selecteableInactiveBowlers
                        btn-label="Activate"
                        hasbtn=True
                        :onsubmit="activateBowler">

                </select-and-submit>
            </v-flex>
        </v-layout>
        <h2>Team Management</h2>
        <v-layout row wrap>
            <v-flex md3 v-for="component in team_components" ma-3>
                <component :is="component"></component>
            </v-flex>
            <v-flex md3 ma-3>
                <select-and-submit
                        title="Activate Team"
                        label="Team"
                        :items=inactiveTeamsForSelect
                        btn-label="Activate"
                        hasbtn=True
                        :onsubmit="doActivateTeam">

                </select-and-submit>
            </v-flex>
            <v-flex md3 ma-3>
                <select-and-submit
                        title="Deactivate Team"
                        label="Team"
                        :items=activeTeamsForSelect
                        btn-label="Deactivate"
                        hasbtn=True
                        :onsubmit="doDeactivateTeam">

                </select-and-submit>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import axios from "axios";
    import AddBowler from './AddBowler';
    import AddSeason from './AddSeason';
    import SelectAndSubmit from "./SelectAndSubmit";
    export default {
        name: 'management',
        components: {
            SelectAndSubmit,
            AddBowler
        },
        data: function() {
            return {
                bowler_components: [ AddBowler],
                team_components: [AddSeason],
            }
        },
        methods: {
           changeActivenessBase: async function(activating, id, collection,
                                                url){
              let newActive = activating ? 1 : 0;
              let item = collection.find((element) => {
                 return element.id === id;
              });
              let clone = JSON.parse(JSON.stringify(item));

              if(clone){
                 clone.active = newActive;
              }
              else {
                 console.warn("Couldn't find item: " + id + " to toggle");
                 return;
              }
              console.log("Sending: " + JSON.stringify(clone));
              const URL = url + clone.id.toString();
              await axios({
                 method: "PUT",
                 url: URL,
                 data: clone,
                 headers: {
                    "content-type": "application/json"
                 }
              }).then(
                 result => {
                    console.log("Ok: " + JSON.stringify(result.data));
                 },
                 error => {
                    console.log("Error while toggling: " +
                       error);
                 }
              );

           },
           activateBowler: async function(b) {
              await this.changeActivenessBase(true, b,
                 this.$store.getters.inactiveBowlers,
              "https://nostyleguy.com/api/bowlers/");
              this.$store.dispatch('getBowlers');
           },
           deactivateBowler: async function(b) {
              await this.changeActivenessBase(false, b,
                 this.$store.getters.activeBowlers,
                 "https://nostyleguy.com/api/bowlers/");
              this.$store.dispatch('getBowlers');
           },
           doActivateTeam: async function(t) {
              await this.changeActivenessBase(true, t,
                 this.$store.getters.inactiveTeams,
                 "https://nostyleguy.com/api/teams/");
              this.$store.dispatch('getTeams');
           },
           doDeactivateTeam: async function(t) {
              await this.changeActivenessBase(false, t,
                 this.$store.getters.activeTeams,
                 "https://nostyleguy.com/api/teams/");
              this.$store.dispatch('getTeams');
           },
           dbBowlerToFrontendBowler(b){
              return {
                 name: b.first_name + " " + b.last_name,
                 id: b.id,
                 active: b.active,
              }
           },
           dbTeamToFrontendTeam(t){
             return {
                name: `${t.name} (${t.year} ${t.season})`,
                id: t.id
             }
           }
       },
       computed: {
          selecteableActiveBowlers(){
             return this.$store.getters.activeBowlers.map(this.dbBowlerToFrontendBowler);
          },
          selecteableInactiveBowlers(){
             return this.$store.getters.inactiveBowlers.map(this.dbBowlerToFrontendBowler);
          },
          activeTeamsForSelect(){
             return this.$store.getters.activeTeams.map(this.dbTeamToFrontendTeam);
          },
          inactiveTeamsForSelect(){
             return this.$store.getters.inactiveTeams.map(this.dbTeamToFrontendTeam);
          }
       },
       mounted: async function(){
          this.$store.dispatch('getTeams');
          this.$store.dispatch('getBowlers');
       }
   }
</script>

<style scoped>

</style>